import type { GameMeta } from '@gmp/game-sdk';

export { STAR_CATEGORIES, STAR_CATEGORY_IDS, type StarCategory } from './categories';

/** Catalog data only (no rules or names), so menus can show the game without loading it. */
export const starStruckMeta = {
  id: 'star-struck',
  name: 'Star Struck',
  tagline: 'Two teams. One minute. Get them to say the name.',
  description:
    'Split into two teams. On your turn a famous name pops up on your phone only: get your team to say it before the clock runs out. Round 1 you can say anything (but never the name), Round 2 just one word, Round 3 no words at all. Same names every round, so the table gets sharper as it goes. With 2 or 3 (or any number) play Co-op: everyone on one team chasing your best score.',
  minPlayers: 2,
  maxPlayers: 20,
  estimatedMinutes: [20, 40],
  usesMedia: false,
  modes: [
    { id: 'teams', name: 'Teams', description: 'Two teams (4–20 players). Describe it, then one word, then act it out: the same names each round.' },
    { id: 'coop', name: 'Co-op', description: 'Everyone on one team (2–20 players), taking turns to give clues, chasing your best score.' },
  ],
  theme: { primary: '#ff5d8f', secondary: '#3ec1d3', background: '#120d1f', ink: '#fff4fb' },
  readiness: 'beta',
  genre: 'Team clue-giving',
  controls: 'tap',
  category: 'party',
  instructions: [
    { icon: 'Users', title: 'Two teams, or Co-op', body: 'Teams (4+): balanced for you, taking turns. Co-op (2+): everyone together, beating your best score. Everyone gives clues once a round.' },
    { icon: 'Star', title: 'Your turn', body: 'A name appears on your phone only. Get your team to say it. Never say the name, part of it, a rhyme or "sounds like".' },
    { icon: 'Timer', title: 'Beat the clock', body: 'Correct is +1. Skip or Fault (you broke a rule) is −1. Get through as many as you can before time runs out.' },
    { icon: 'MessageCircle', title: 'Round 2: one word', body: 'The same names come back shuffled. This time you get exactly one word per name.' },
    { icon: 'Theater', title: 'Round 3: act it out', body: 'Same names again. No words or sounds at all: mime only. Highest team total after three rounds wins.' },
  ],
} satisfies GameMeta;
